import * as React from "react"

const useIntersectionObserver = async (resourceUrl, elementId) => {
  const [loaded, setLoaded] = React.useState(false)
  const [observer, setObserver] = React.useState(null)
  const [observerOptions, setObserverOptions] = React.useState({
    root: null,
    rootMargin: "0px",
    threshold: 1,
  })

  React.useEffect(() => {
    const options = {
      root: null,
      rootMargin: "0px",
      threshold: 1,
    }
    const observer = new IntersectionObserver((entries) => {
      if (entries[0].isIntersecting) {
        setLoaded(true)
        console.log("loaded")
        const script = document.createElement("script")
        script.async = false
        script.defer = true
        script.src = resourceUrl
        document.body.appendChild(script)
        observer.disconnect()

        return () => {
          document.body.removeChild(script)
        }
      }
    }, options)
    setObserver(observer)
    setObserverOptions(options)
  }, [])

  React.useEffect(() => {
    if (observer) {
      observer.observe(document.querySelector(elementId))
    }
  }, [observer])
}
export default useIntersectionObserver
